import { Box, Typography } from "@mui/material";
import Logo from "./../../assets/images/icons/Logo.svg";
import Styles from "./PageLoader.module.scss";

const PageLoader = () => {
  return (
    <Box
      className={Styles.page_loader}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        height: "100vh",
      }}
    >
      <div className={Styles.logo_container}>
        <img src={Logo} alt="SHVR logo" height={60} />
        <Typography className={Styles.logo_text}>
          Swachh Evam
          <br />
          Harit Vidyalaya
        </Typography>
      </div>
      <Typography
        fontWeight={400}
        color="#000"
        marginTop={"2rem"}
        sx={{ fontSize: { xs: "0.75em", md: "1em" } }}
      >
        Loading...
      </Typography>
    </Box>
  );
};

export default PageLoader;
